import React from 'react';
import styles from './Scoreboard.module.css';

const Scoreboard = ({ stats, highScores, onReset, title = "Scoreboard" }) => {
    return (
        <div>
            {Object.entries(stats).map(([key, value]) => (
                <div key={key}>
                    {key.charAt(0).toUpperCase() + key.slice(1)}: <span>{value}</span>
                </div>
            ))}

            <hr style={{ opacity: 0.3, margin: '15px 0' }} />

            <strong>{title}</strong>
            <div className={styles.small}>
                {highScores.length > 0 ? (
                    <table className={styles.scoreTable}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Score</th>
                                <th>Size</th>
                                <th>Time</th>
                                <th>Acc</th>
                            </tr>
                        </thead>
                        <tbody>
                            {highScores.map((s, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>
                                        {s.hf !== undefined ? s.hf.toFixed(4) : '-'}
                                    </td>
                                    <td>
                                        {s.size || '-'}
                                    </td>
                                    <td>
                                        {s.time !== undefined && typeof s.time === 'number' ? s.time.toFixed(3) + 's' : s.time || '-'}
                                        {/* Fallback for regular Score (TargetSpeed) if we want? */}
                                        {s.score !== undefined ? `${s.score} pts` : ''}
                                    </td>
                                    <td>
                                        {s.hits !== undefined ? `${s.hits}/${s.hits + s.misses}` : '-'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div style={{ opacity: 0.5 }}>No scores yet</div>
                )}
            </div>
            {onReset && <button onClick={onReset} style={{ marginTop: '10px', width: 'fit-content', display: 'block' }}>Reset Scores</button>}
        </div>
    );
};

import PropTypes from 'prop-types';

Scoreboard.propTypes = {
    stats: PropTypes.object.isRequired,
    highScores: PropTypes.array.isRequired,
    onReset: PropTypes.func,
    title: PropTypes.string
};

export default Scoreboard;
